import React, { useEffect } from 'react'
import { config } from '../../../../../config/config'
import { onClientSide, sendDispatchEvent } from 'utils/utils'
import Button from '@/components/Button'
import useModal from '@/modern/actions/useModal'
import ModalContainer from '@/modern/components/ModalContainer'
import SuccessModal from '../SuccessModal'
import LoadingModal from '../LoadingModal'
import { useFetchGrantConsent } from '../useFetchGrantConsent'
import * as S from '../style'

function ServerErrorModal({ email }) {
  const { closeModal, modal } = useModal('promoBlackFairServerErrorModal')
  const { isLoading, result, fetchConsent } = useFetchGrantConsent(email)


  function handleCloseModal(event) {
    if (!onClientSide()) return
    if (event) {
      event.stopPropagation()
    }
    closeModal()
  }

  function handleGrantConsent() {
    if (!onClientSide()) return
    sendDispatchEvent('cliquePosLeadQueroParticiparSorteio')
    fetchConsent(email)
  }

  useEffect(() => {
    if (onClientSide()) {
      if (modal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
      return () => {
        document.body.style.overflow = ''
      }
    }
  }, [modal])

  if (isLoading) {
    return <LoadingModal />
  }

  if (result.success || result.statusCode === 400) {
    if (!onClientSide()) return
    window.localStorage.setItem(config.promoBlackFairao2024, true)

    return (
      <SuccessModal email={email} />
    )
  }

  return (
    <ModalContainer
      align="center"
      show={modal}
      useWhiteBox
      onBgClick={e => handleCloseModal(e)}
    >
      <S.WrapperError>
        <S.CloseButton onClick={e => handleCloseModal(e)}>
          <S.CloseIcon name="Close_1" fill="#2E2E37" size="24" />
        </S.CloseButton>
        <S.ImageContainer>
          <img
            src="/assets/img/webp/Icon-error.webp"
            alt="Erro de servidor"
          />
        </S.ImageContainer>
        <S.HeadingEmail>Ops! Algo não saiu como esperado.< br/> Por favor, tente novamente.</S.HeadingEmail>
        <S.ButtonsContainerError>
          <Button className="server-error" onClick={() => handleGrantConsent()}>Tentar novamente</Button>
        </S.ButtonsContainerError>
      </S.WrapperError>
    </ModalContainer>
  )
}

export default ServerErrorModal